import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/icons";
import "../theme/index.css";
import ElementUI from "element-ui";
import "animate.css";
import "@/assets/baiduMapKey/BaiduMapKey"
import "@/assets/baiduMapKey/xxpp"

// import './static/ueditor-1.4.3.3/ueditor.config'
// import './static/ueditor-1.4.3.3/ueditor.all.min'
// import './static/ueditor-1.4.3.3/lang/zh-cn/zh-cn'

localStorage.setItem("deviceWidth", "1920"); //设置设计稿默认宽度
import "./assets/utils/phone";
import SlideVerify from "vue-monoplasty-slide-verify";
import Bus from "@/assets/utils/bus.js";
import copy from "@/assets/utils/deepClone";
import { Objects } from "@/assets/utils/Object";
import { Arrays } from "@/assets/utils/Array";
import Watermark from "@/assets/utils/Watermark.js";
import "./assets/utils/PlanMapHeight";
import DynamicButton from "@/components/DynamicButton.vue";
import Countdown from "@/components/Countdown.vue";
import wintacUI from "@/components/Wintac-ui/components";
import websocket1 from "@/assets/websocket/Websocket1";

Vue.use(wintacUI);
Vue.use(SlideVerify);
Vue.config.productionTip = false;
Vue.prototype.$Bus = Bus;
Vue.use(ElementUI);
Vue.prototype.copy = copy;
Vue.prototype.$Objects = Objects;
Vue.prototype.$websocket = websocket1;

//全屏水印
Vue.prototype.$Watermark = Watermark;
Vue.prototype.$Arrays = Arrays;
Vue.component("DynamicButton", DynamicButton);
Vue.component("Countdown", Countdown);
Vue.filter("dateFormat", function (originVal) {
  const dt = new Date(originVal);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");
  return `${y}-${m}-${d}`;
});
Vue.filter("dateFormatHms", function (originVal) {
  const dt = new Date(originVal);

  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");

  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
});



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 全局混入
import { dateUtil } from "@/mixins/dateUtil.js";
Vue.mixin(dateUtil);
